@if (itemType) {
  <div class="item-type-chip" [ngClass]="itemType">
    <span [class.gb-truncate]="!disableTruncate">{{ translateKey | translate }}</span>
  </div>
}
